"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftRatingMetricQuestionsDtoMetricsValue = instanceOfShiftRatingMetricQuestionsDtoMetricsValue;
exports.ShiftRatingMetricQuestionsDtoMetricsValueFromJSON = ShiftRatingMetricQuestionsDtoMetricsValueFromJSON;
exports.ShiftRatingMetricQuestionsDtoMetricsValueFromJSONTyped = ShiftRatingMetricQuestionsDtoMetricsValueFromJSONTyped;
exports.ShiftRatingMetricQuestionsDtoMetricsValueToJSON = ShiftRatingMetricQuestionsDtoMetricsValueToJSON;
exports.ShiftRatingMetricQuestionsDtoMetricsValueToJSONTyped = ShiftRatingMetricQuestionsDtoMetricsValueToJSONTyped;
/**
 * Check if a given object implements the ShiftRatingMetricQuestionsDtoMetricsValue interface.
 */
function instanceOfShiftRatingMetricQuestionsDtoMetricsValue(value) {
    return true;
}
function ShiftRatingMetricQuestionsDtoMetricsValueFromJSON(json) {
    return ShiftRatingMetricQuestionsDtoMetricsValueFromJSONTyped(json, false);
}
function ShiftRatingMetricQuestionsDtoMetricsValueFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShiftRatingMetricQuestionsDtoMetricsValueToJSON(json) {
    return ShiftRatingMetricQuestionsDtoMetricsValueToJSONTyped(json, false);
}
function ShiftRatingMetricQuestionsDtoMetricsValueToJSONTyped(value, ignoreDiscriminator = false) {
    return value;
}
//# sourceMappingURL=ShiftRatingMetricQuestionsDtoMetricsValue.js.map